import { createSlice } from "@reduxjs/toolkit";
import {  getIcomeOverViewThunk, getIncomeDetailThunk, getOrderDetailIncomeThunk, getOrderIncomeStatementThunk, getStatementOrderDetailThunk } from "./thunks";

export const initialState: any = {
    IcomeOverView: [],
    IcomeOverViewDetail: [],
    statementOrderDetail:{},
    orderStatementIncome: [],
incomeOrderDetail:{},
    IncomeDetailList:[],
};

const OrderStatmentReducer = createSlice({
  name: "OrdersSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getIcomeOverViewThunk.fulfilled, (state: any, action: any) => {
      state.IcomeOverView = action.payload.data;
      state.counts = action.payload.counts;
    });

    builder.addCase(getIcomeOverViewThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
     builder.addCase(getStatementOrderDetailThunk.fulfilled, (state: any, action: any) => {
      state.IcomeOverViewDetail = action.payload;
      state.counts = action.payload.counts;
    });

    builder.addCase(getStatementOrderDetailThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(getOrderDetailIncomeThunk.fulfilled, (state: any, action: any) => {
      state.incomeOrderDetail = action.payload;
    });

    builder.addCase(getOrderDetailIncomeThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
      builder.addCase(getIncomeDetailThunk.fulfilled, (state: any, action: any) => {
      state.IncomeDetailList = action.payload.data;
      state.counts = action.payload.counts;
    });

    builder.addCase(getIncomeDetailThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    
      builder.addCase(getOrderIncomeStatementThunk.fulfilled, (state: any, action: any) => {
        
      state.orderStatementIncome = action?.payload?.data;
      state.counts = action.payload.counts;
    });

    builder.addCase(getOrderIncomeStatementThunk.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
  },
});

export default OrderStatmentReducer.reducer;
